/**
 * Legacy InventoryApiService module — preserved as an empty AngularJS module
 * so existing dependencies (`acme.common.service.inventoryApi`) keep resolving.
 *
 * The actual InventoryApiService is now exposed through the Angular 18
 * ApiService facade. Implementation:
 *   apps/b2b-frontend/app/core/api/inventory/inventory-api.service.ts
 */
angular.module("acme.common.service.inventoryApi", [
  "acme.common.factory.apiVersion",
  "acme.common.factory.QueryStringBuilder",
]);
